@app.service 'LocationService', ($q, $http, csConfig) ->

  @location = null
  @forceUS = false

  @loadData = =>
    deferred = $q.defer()
    if @location?
      deferred.resolve(@location)
    else
      $http.get("#{csConfig.chefstepsEndpoint}/api/v0/locations.json").then(
        (response) =>
          @location = response.data
          deferred.resolve(@location)
        ,(error) ->
          deferred.reject(error)
      )
    deferred.promise

  # Location awareness methods
  @getCountry = =>
    @location?.country

  @isInUS = =>
    (@forceUS || (@getCountry() == 'US') || (@getCountry() == null))

  @forceInUS = ->
    @forceUS = true

  this
